var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeleteNoteAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 30,
    rx: 14.5,
    fill: "#E4E7EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9396 13.0923L19.4584 19.6079C19.3589 20.9557 18.2242 22 16.8568 22H12.1435C10.7769 22 9.64141 20.9557 9.54195 19.6072L9.06066 13.0923M21 10.6464H8M17.466 10.6456L17.0704 8.71967C16.9557 8.29514 16.5662 8.00001 16.1224 8.00001H12.8812C12.4351 7.9985 12.0441 8.29363 11.9286 8.71967L11.5368 10.6456M13.0069 14.8303V18.3371M15.6655 14.8303V18.3371",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteNoteAction);
export default __webpack_public_path__ + "static/media/delete-note-action.1360583dfe3d4a24aee2259c59c7eb92.svg";
export { ForwardRef as ReactComponent };